
import React, { Component } from 'react';

import Select from 'react-select';

import { FormGroup, InputGroup, FormText, Button, Label, Modal, ModalHeader, ModalBody, FormFeedback } from 'reactstrap';
import InputTextComponent from "../../../components/forms/InputTextComponent";
import DatePicker from '../../../components/forms/DatePicker';

const logger = require('../../../utils/logger/logger.js');
const dateUtil = require('../../../utils/dateUtil/dateUtil.js');
const stringUtil = require('../../../utils/string/stringUtil.js');
const translator = require('../../../utils/translator/translator');

class HolidayDialogue extends Component
{
    constructor(props)
    {
        super(props);

        this.onClose = this.onClose.bind(this);
        this.onSave = this.onSave.bind(this);
        this.validate = this.hasError.bind(this);

        this.renderBodyComponent = this.renderBodyComponent.bind(this);
        this.renderFullDayComponent = this.renderFullDayComponent.bind(this);
        this.renderPartialDayComponent = this.renderPartialDayComponent.bind(this);
        this.handleDatePickerOutsideClick = this.handleDatePickerOutsideClick.bind(this);
        this.handleFromDateChange = this.handleFromDateChange.bind(this);
        this.handleToDateChange = this.handleToDateChange.bind(this);

        this.fromDatePickerContainerRef = React.createRef(null);
        this.toDatePickerContainerRef = React.createRef(null);

        this.state = 
        {
            error: 
            {
                fieldName: null,
                message: null,
            },
            showFromDatePicker: false,
            showToDatePicker: false,
        };
    }

    handleDatePickerOutsideClick() 
    {
        this.setState({ showFromDatePicker: false, showToDatePicker: false });
    }

    handleFromDateChange(newDate)
    {
        if (newDate)
        {
            this.props.bookedHoliday.fromDate = newDate;
            this.setState({ showFromDatePicker: false });
        }
    }

    handleToDateChange(newDate)
    {
        if (newDate)
        {
            this.props.bookedHoliday.toDate = newDate;
            this.setState({ showToDatePicker: false });
        }
    }

    render()
    {
        const partialDayBooleanOptions = 
        [
            { label: translator.getLabel('no'), value: false },
            { label: translator.getLabel('yes'), value: true }
        ];

        const partialDaySelectedOption = partialDayBooleanOptions.find(option => option.value === !this.props.bookedHoliday.isFullDay);

        return  <Modal isOpen={true} animation={false} fade={false} toggle={this.onClose} size="lg" style={{ maxWidth: '1600px', width: '90%' }}>
                    <ModalHeader
                        close={
                            <div>
                                <Button className="btn-cancel" onClick={this.onClose}>{translator.getLabel("cancel")}</Button>&nbsp;&nbsp;
                                <Button className="btn-ok" type="submit" onClick={this.onSave}>{translator.getLabel("done")}</Button>
                            </div>
                        }>
                        <span className="window-title">{translator.getLabel("holidays")} - {this.getStatus()}</span>
                    </ModalHeader>
                    <ModalBody>
                        <div>
                            <FormGroup {...this.props}>
                                <div className='d-flex flex-column'>
                                    <div>
                                        <Label style={{ marginRight: '1.0rem', marginBottom: '0' }}>{translator.getLabel("are_you_looking_for_partial_day_off")}</Label>
                                        <div style={{width:"50%"}} >
                                            <Select
                                                options={partialDayBooleanOptions} 
                                                value={partialDaySelectedOption} 
                                                placeholder={translator.getLabel("are_you_looking_for_partial_day_off")}
                                                isClearable={false}
                                                onChange={(selectedValue) =>
                                                {
                                                    this.props.bookedHoliday.isFullDay = !selectedValue.value;

                                                    if (this.props.bookedHoliday.isFullDay)
                                                    {
                                                        this.props.bookedHoliday.fromDate = dateUtil.getDateComponent(this.props.bookedHoliday.fromDate);
                                                        this.props.bookedHoliday.toDate = dateUtil.getDateComponent(this.props.bookedHoliday.toDate);
                                                    }
                                                    else
                                                    {
                                                        this.props.bookedHoliday.fromDate = dateUtil.getDateComponent(this.props.bookedHoliday.fromDate);
                                                        this.props.bookedHoliday.toDate = this.props.bookedHoliday.fromDate;
                                                    }
                                                    this.setState({});
                                                }} />
                                        </div>
                                    </div>
                                    <FormText color="muted">{translator.getLabel("indicates_if_you_are_off_for_part_of_the_day")}</FormText>
                                </div>
                            </FormGroup>

                            <hr style={{ marginTop: '-8px', marginBottom: '30px' }} />

                            {this.renderBodyComponent()}

                            <FormGroup {...this.props}>
                                {translator.getLabel("instructions")}
                                <InputTextComponent style={{ height: 'var(--button-height)' }} disabled={false} placeholder={`${translator.getLabel("enter_notes")}`}
                                    value={this.props.bookedHoliday.notes}
                                    inputTextType="text"
                                    onValueChange={(value) =>
                                    {
                                        this.props.bookedHoliday.notes = value;
                                        this.setState({});
                                    }} />
                                <FormText color="muted">{translator.getLabel("enter_any_further_details_for_holiday_requests")}</FormText>
                            </FormGroup>
                            {
                                stringUtil.isStringNullOrEmpty(this.props.bookedHoliday.rejectionNotes) ? null :
                                    <div className="text-muted" style={{ marginTop: '0px', marginBottom: '10px' }}>
                                        {translator.getLabel("rejection_reason")}: {this.props.bookedHoliday.rejectionNotes}
                                    </div>
                            }
                        </div>
                        <DatePicker
                            value={this.props.bookedHoliday.fromDate}
                            innerRef={this.fromDatePickerContainerRef}
                            isOpen={this.state.showFromDatePicker}
                            onChange={this.handleFromDateChange}
                            onOutSideClick={this.handleDatePickerOutsideClick}/>
                        <DatePicker
                            value={this.props.bookedHoliday.toDate}
                            innerRef={this.toDatePickerContainerRef}
                            isOpen={this.state.showToDatePicker}
                            onChange={this.handleToDateChange}
                            onOutSideClick={this.handleDatePickerOutsideClick}/>
                    </ModalBody>
                </Modal>;
    }

    renderBodyComponent()
    {
        if (this.props.bookedHoliday.isFullDay)
            return this.renderFullDayComponent();

        return this.renderPartialDayComponent();
    }

    renderFullDayComponent()
    {
        let fromClassName = this.state.error.fieldName === 'fromDate' ? 'form-control is-invalid' : 'form-control';
        let toClassName = this.state.error.fieldName === 'toDate' ? 'form-control is-invalid' : 'form-control';

        return <FormGroup>
            <div className='d-flex flex-column'>
                <div className="flex-row d-flex" >
                    <div style={{width:"50%", marginRight: '0.5rem'}}>
                        <FormGroup>
                            <div>{translator.getLabel("from_date")}</div>
                            <div 
                                className={fromClassName}
                                ref={this.fromDatePickerContainerRef}
                                onClick={() =>
                                    {
                                        this.setState(prev => ({ showFromDatePicker: !prev.showFromDatePicker, error: { fieldName: null, message: null }}))
                                    }}>
                                    {dateUtil.getDateComponent(this.props.bookedHoliday.fromDate) || <div style={{color: '#808080'}}> {translator.getLabel("enter_from_date")}</div>}
                            </div>
                            <FormFeedback>
                                {this.state.error.fieldName === "fromDate" ? this.state.error.message : null}
                            </FormFeedback>
                            <FormText color="muted">{translator.getLabel("enter_from_date")}</FormText>
                        </FormGroup>
                    </div>
                    <div style={{width:"50%", marginLeft: '0.5rem'}}>
                        <FormGroup>
                            <div>{translator.getLabel("to_date")}</div>
                            <div
                                className={toClassName}
                                ref={this.toDatePickerContainerRef}
                                onClick={() =>
                                    {
                                        this.setState(prev => ({ showToDatePicker: !prev.showToDatePicker, error: { fieldName: null, message: null }}))
                                    }}>
                                    {dateUtil.getDateComponent(this.props.bookedHoliday.toDate) || <div style={{color: '#808080'}}> {translator.getLabel("enter_to_date")} </div>}
                            </div>
                            <FormFeedback>
                                {this.state.error.fieldName === "toDate" ? this.state.error.message : null}
                            </FormFeedback>
                            <FormText color="muted">{translator.getLabel("enter_to_date")}</FormText>
                        </FormGroup>
                    </div>
                </div>
            </div>
        </FormGroup>;
    }

    renderPartialDayComponent()
    {
        var fromHour = dateUtil.formatDate(dateUtil.convertToLocalStandard(this.props.bookedHoliday.fromDate), "HH")
        var fromMinutes = dateUtil.formatDate(dateUtil.convertToLocalStandard(this.props.bookedHoliday.fromDate), "mm")

        var toHour = dateUtil.formatDate(dateUtil.convertToLocalStandard(this.props.bookedHoliday.toDate), "HH")
        var toMinutes = dateUtil.formatDate(dateUtil.convertToLocalStandard(this.props.bookedHoliday.toDate), "mm")

        fromHour = { value: fromHour, label: fromHour };
        fromMinutes = { value: fromMinutes, label: fromMinutes };
        toHour = { value: toHour, label: toHour };
        toMinutes = { value: toMinutes, label: toMinutes };

        return (<table>
            <tr>
                <td>
                    <FormGroup>
                        <div style={{ marginBottom: '8px' }}>{translator.getLabel("from_time")}</div>
                        <InputGroup>
                            <Label style={{ paddingRight: '5px', paddingTop: '10px' }}>{translator.getLabel("hrs")}:</Label>
                            <Select
                                value={fromHour}
                                options={this.getPossibleHours()}
                                disabled={this.props.bookedHoliday.isLocked}
                                placeholder={translator.getLabel("hrs")}
                                clearable={false}
                                onChange={(optionValue) =>
                                {
                                    if (optionValue == null || stringUtil.isStringNullOrEmpty(optionValue.value))
                                    {
                                        let fromDate = dateUtil.convertToLocalStandard(this.props.bookedHoliday.fromDate);
                                        fromDate = dateUtil.setHours(fromDate, 0);
                                        fromDate = dateUtil.setMinutes(fromDate, 0);
                                        this.props.bookedHoliday.fromDate = dateUtil.convertToUTCStandard(fromDate);
                                    }
                                    else
                                    {
                                        let fromDate = dateUtil.convertToLocalStandard(this.props.bookedHoliday.fromDate);
                                        fromDate = dateUtil.setHours(fromDate, optionValue.value);
                                        this.props.bookedHoliday.fromDate = dateUtil.convertToUTCStandard(fromDate);
                                    }

                                    this.setState({});
                                }} />
                            <Label style={{ paddingLeft: '10px', paddingRight: '5px', paddingTop: '10px' }}>{translator.getLabel("mins")}:</Label>
                            <Select
                                value={fromMinutes}
                                options={this.getPossibleMinutes()}
                                disabled={this.props.bookedHoliday.isLocked}
                                placeholder={translator.getLabel("mins")}
                                clearable={false}
                                onChange={(optionValue) =>
                                {
                                    if (optionValue == null || stringUtil.isStringNullOrEmpty(optionValue.value))
                                    {
                                        let fromDate = dateUtil.convertToLocalStandard(this.props.bookedHoliday.fromDate);
                                        fromDate = dateUtil.setHours(fromDate, 0);
                                        fromDate = dateUtil.setMinutes(fromDate, 0);
                                        this.props.bookedHoliday.fromDate = dateUtil.convertToUTCStandard(fromDate);
                                    }
                                    else
                                    {
                                        let fromDate = dateUtil.convertToLocalStandard(this.props.bookedHoliday.fromDate);
                                        fromDate = dateUtil.setMinutes(fromDate, optionValue.value);
                                        this.props.bookedHoliday.fromDate = dateUtil.convertToUTCStandard(fromDate);
                                    }
                                    this.setState({});
                                }} />
                        </InputGroup>
                    </FormGroup>
                </td>

                <td>
                    <div style={{ marginRight: '40px' }}></div>
                </td>

                <td>
                    <FormGroup>
                        <div style={{ marginBottom: '8px' }}>{translator.getLabel("to_time")}</div>
                        <InputGroup>
                            <Label style={{ paddingRight: '5px', paddingTop: '10px' }}>{translator.getLabel("hrs")}:</Label>
                            <Select
                                value={toHour}
                                options={this.getPossibleHours()}
                                disabled={this.props.bookedHoliday.isLocked}
                                placeholder={translator.getLabel("hrs")}
                                clearable={false}
                                onChange={(optionValue) =>
                                {
                                    if (optionValue == null || stringUtil.isStringNullOrEmpty(optionValue.value))
                                    {
                                        let toDate = dateUtil.convertToLocalStandard(this.props.bookedHoliday.toDate);
                                        toDate = dateUtil.setHours(toDate, 0);
                                        toDate = dateUtil.setMinutes(toDate, 0);
                                        this.props.bookedHoliday.toDate = dateUtil.convertToUTCStandard(toDate);
                                    }
                                    else
                                    {
                                        let toDate = dateUtil.convertToLocalStandard(this.props.bookedHoliday.toDate);
                                        toDate = dateUtil.setHours(toDate, optionValue.value);
                                        this.props.bookedHoliday.toDate = dateUtil.convertToUTCStandard(toDate);
                                    }
                                    this.setState({});
                                }} />
                            <Label style={{ paddingLeft: '10px', paddingRight: '5px', paddingTop: '10px' }}>{translator.getLabel("mins")}:</Label>
                            <Select
                                value={toMinutes}
                                options={this.getPossibleMinutes()}
                                disabled={this.props.bookedHoliday.isLocked}
                                placeholder={translator.getLabel("mins")}
                                clearable={false}
                                onChange={(optionValue) =>
                                {
                                    if (optionValue == null || stringUtil.isStringNullOrEmpty(optionValue.value))
                                    {
                                        let toDate = dateUtil.convertToLocalStandard(this.props.bookedHoliday.toDate);
                                        toDate = dateUtil.setHours(toDate, 0);
                                        toDate = dateUtil.setMinutes(toDate, 0);
                                        this.props.bookedHoliday.toDate = dateUtil.convertToUTCStandard(toDate);
                                    }
                                    else
                                    {
                                        let toDate = dateUtil.convertToLocalStandard(this.props.bookedHoliday.toDate);
                                        toDate = dateUtil.setMinutes(toDate, optionValue.value);
                                        this.props.bookedHoliday.toDate = dateUtil.convertToUTCStandard(toDate);
                                    }
                                    this.setState({});
                                }} />
                        </InputGroup>
                    </FormGroup>
                </td>
            </tr>
        </table>)
    }

    onClose()
    {
        logger.usage("Holidays.Dialogue.Cancel", "Staff clicked Cancel button to dismiss Holiday Dialogue");
        
        if (this.props.onCancel)
            this.props.onCancel();
    }

    onSave()
    {
        logger.usage("Holidays.Dialogue.Done", "Staff clicked Done button to save Holiday");

        this.hasError();

        if (this.state.error.fieldName != null || this.state.error.message != null)
        {
            this.setState({});
            return;
        }

        if (this.props.onSave)
            this.props.onSave(this.props.bookedHoliday);
    }

    hasError()
    {
        if (stringUtil.isStringNullOrEmpty(this.props.bookedHoliday.fromDate))
        {
            this.state.error.fieldName = "fromDate";
            this.state.error.message = translator.getLabel("from_date_cannot_be_left_empty");
        }

        else if (stringUtil.isStringNullOrEmpty(this.props.bookedHoliday.toDate))
        {
            this.state.error.fieldName = "toDate";
            this.state.error.message = translator.getLabel("to_date_cannot_be_left_empty");
        }

        else if (dateUtil.isBefore(this.props.bookedHoliday.toDate, this.props.bookedHoliday.fromDate))
        {
            this.state.error.fieldName = "fromDate";
            this.state.error.message = translator.getLabel("from_date_cannot_be_after_to_date");
        }

        else if (dateUtil.isBefore(this.props.bookedHoliday.fromDate, dateUtil.addDays(dateUtil.getToday(), 20)))
        {
            this.state.error.fieldName = "fromDate";
            this.state.error.message = translator.getLabel("date_cannot_be_less_than_20_days_from_today");
        }
    }

    getPossibleHours()
    {
        var options = [];

        for (var i = 0; i <= 23; i++)
        {
            var formattedString = i + "";
            formattedString = formattedString.padStart(2, '0');

            let option = {};
            option.value = formattedString;
            option.label = formattedString;
            options.push(option);
        }
        return options;
    }

    getPossibleMinutes()
    {
        var options = [];

        for (var i = 0; i <= 59; i++)
        {
            var formattedString = i + "";
            formattedString = formattedString.padStart(2, '0');

            let option = {};
            option.value = formattedString;
            option.label = formattedString;
            options.push(option);
        }
        return options;
    }

    getStatus()
    {
        if (stringUtil.areStringSame(this.props.bookedHoliday.status, "pending"))
            return translator.getLabel("pending");

        if (stringUtil.areStringSame(this.props.bookedHoliday.status, "approved"))
            return translator.getLabel("approved");

        if (stringUtil.areStringSame(this.props.bookedHoliday.status, "rejected"))
            return translator.getLabel("rejected");
    }
}

export default HolidayDialogue;